import { useLayoutEffect, useState } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function ShowLineChart(props) {



  useLayoutEffect(() => {
    var root = am5.Root.new("chartdiv");


// Set themes
// https://www.amcharts.com/docs/v5/concepts/themes/
root.setThemes([
  am5themes_Animated.new(root)
]);


// Create chart
// https://www.amcharts.com/docs/v5/charts/xy-chart/
var chart = root.container.children.push(am5xy.XYChart.new(root, {
  panX: true,
  panY: true,
  wheelX: "panX",
  wheelY: "zoomXY",
  pinchZoomX: true,
  paddingLeft: 0
}));

chart.get("colors").set("step", 3);


// Add cursor
// https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
cursor.lineY.set("visible", false);


// Create axes
// https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
var xAxis = chart.xAxes.push(am5xy.ValueAxis.new(root, {
  maxDeviation: 0.2,
  // baseInterval: {
  //   timeUnit: "day",
  //   count: 1
  // },
  renderer: am5xy.AxisRendererX.new(root, {
    minorGridEnabled: false,
    minGridDistance: 70,
  }),
  // tooltip: am5.Tooltip.new(root, {})
}));

var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
  maxDeviation: 0.2,
  renderer: am5xy.AxisRendererY.new(root, {
    minorGridEnabled: false,
  })
}));


// xAxis.get("renderer").grid.template.set("forceHidden", true);
// yAxis.get("renderer").grid.template.set("forceHidden", true);

yAxis.children.moveValue(am5.Label.new(root, { text: "Detector Response", rotation: -90, y: am5.p50, centerX: am5.p50 }), 0);
xAxis.children.push(am5.Label.new(root, { text: "Time", x: am5.p50, centerX: am5.p50 }));

var series = chart.series.push(am5xy.LineSeries.new(root, {
  name: "Series",
  xAxis: xAxis,
  yAxis: yAxis,
  valueYField: "y",
  valueXField: "x",
  // tooltip: am5.Tooltip.new(root, {
  //   labelText: "{valueY}"
  // })
}));

series.strokes.template.setAll({
  strokeWidth: 2
});


// Add scrollbar
// https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
// chart.set("scrollbarX", am5.Scrollbar.new(root, {
//   orientation: "horizontal",
//   // height: 60
// }));


let scrollbar = chart.set("scrollbarX", am5xy.XYChartScrollbar.new(root, {
  orientation: "horizontal",
  height: 60
}));

let sbxAxis = scrollbar.chart.xAxes.push(am5xy.ValueAxis.new(root, {
  // baseInterval: {
  //   timeUnit: "x",
  //   count: 1
  // },
  renderer: am5xy.AxisRendererX.new(root, {
    minorGridEnabled: true,
    minGridDistance: 70
  })
}));

let sbyAxis = scrollbar.chart.yAxes.push(
  am5xy.ValueAxis.new(root, {
    renderer: am5xy.AxisRendererY.new(root, {})
  })
);

let sbSeries = scrollbar.chart.series.push(am5xy.LineSeries.new(root, {
  valueYField: 'y',
  valueXField: 'x',
  xAxis: sbxAxis,
  yAxis: sbyAxis
}));




// Set data
series.data.setAll(props.data);
sbSeries.data.setAll(props.data);


// var legend = chart.children.push(am5.Legend.new(root, {})); 
// legend.data.setAll(chart.series.values);


// Make stuff animate on load
// https://www.amcharts.com/docs/v5/concepts/animations/
series.appear(1000);
chart.appear(1000, 100);








// Explanatory labels
chart.plotContainer.children.push(am5.Label.new(root, {
  x: 5,
  y: 5,
  text: props.fileName.split('.').slice(0, -1).join('.')
}));
return () => {
  root.dispose();
};
  });


  return (
    <>
      <div id="chartdiv" style={{width:'100%', height: '100%'}}></div>
    </>
  );
}
export default ShowLineChart;